






















































import { Component, Vue } from 'vue-property-decorator';

import { curNfreshClient, NfreshClient } from '@/services/NfreshClient';
import { Subscription } from '@/types/core-push';

import SectionHeader from '@/components/SectionHeader.vue';
import KeyValue from '@/components/KeyValue.vue';
import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue'; 

import SnsEndpointView from '@/components/subscriptions/SnsEndpointView.vue';
import HttpEndpointView from '@/components/subscriptions/HttpEndpointView.vue';
import KinesisEndpointView from '@/components/subscriptions/KinesisEndpointView.vue';
import SubFilters from '@/components/subscriptions/SubFilters.vue';
import NfreshDeliveryList from '@/components/nfresh/NfreshDeliveryList.vue';
import EnterpriseId from '@/components/EnterpriseId.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';



@Component({
  components: {
    SectionHeader,
    KeyValue,
    VueError,
    Success,
    SnsEndpointView,
    HttpEndpointView,
    KinesisEndpointView,
    EnterpriseId,
    SubFilters,
    TimestampAgo,
    NfreshDeliveryList
  },
})
export default class SingleSubscription extends Vue {

  sub:Subscription = {} as Subscription;
  
  errorMsg:string = '';

  // internal dependencies
  private nfreshClient:NfreshClient = curNfreshClient;

  async mounted() {

    this.refresh();
  }

  async refresh() {

    const subId = parseInt(this.$route.params.subId, 10);

    if(isNaN(subId))
      return this.$router.push({name:'subscriptions'});

    const reply = await this.nfreshClient.getSubscription({subId});

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(reply.errorMsg)
      return this.errorMsg = `Unable to retrieve subscription ${this.$route.params.subId}: ${reply.errorMsg}`;

    this.sub = reply.sub!;
  }

  get infoIconList():object[] {
    return [
      {name:'arrow-left', title:'back to sub list', event:'sub-list'}
    ];
  }

  goToNfreshSubList() {
    return this.$router.push({name:'applications-nfresh-subscriptions'});
  }
  
}
